import * as React from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

import LoansQuery from '../../components/queries/LoansQuery'
import Loading from '../../components/Loading'
import Headline from '../../components/Headline'
import HeaderContainer from '../../components/HeaderContainer'

import AdminLoansTable from './AdminLoansTable'
import AdminClosedLoansTable from './AdminClosedLoansTable'

const DashboardAdmin: React.SFC = () => (
  <React.Fragment>
    <HeaderContainer>
      <Headline>Půjčky</Headline>
      <ButtonToolbar>
        <LinkContainer to="/loans/create">
          <Button id="create-loan">Vytvořit půjčku</Button>
        </LinkContainer>
      </ButtonToolbar>
    </HeaderContainer>
    <LoansQuery variables={{ closed: false }}>
      {({ loading, data, error }) => {
        if (loading) {
          return <Loading />
        }

        if (data == null || error != null) {
          return <div>Error</div>
        }

        return <AdminLoansTable loans={data.loans} />
      }}
    </LoansQuery>
    <HeaderContainer>
      <Headline>Historie změn</Headline>
    </HeaderContainer>
    <LoansQuery variables={{ closed: true }}>
      {({ loading, data, error }) => {
        if (loading) {
          return <Loading />
        }

        if (data == null || error != null) {
          return <div>Error</div>
        }

        return <AdminClosedLoansTable loans={data.loans} />
      }}
    </LoansQuery>
  </React.Fragment>
)

export default DashboardAdmin



// WEBPACK FOOTER //
// ./src/screens/dashboard/DashboardAdmin.tsx